import { FC } from 'react'

import Typography from 'src/components/ui/atoms/Typography'
import { cn } from 'src/lib/cn'
import useSidebarStore from 'src/stores/useSidebarStore'
import { FetchAppMenuResponseInterface } from 'src/types/AppMenuInterface'
import SidebarProductsProduct from './SidebarProductsProduct'

interface SidebarProductsCategoryProps {
  category: FetchAppMenuResponseInterface[0]
}

const SidebarProductsCategory: FC<SidebarProductsCategoryProps> = ({ category }) => {
  const isSidebarOpen = useSidebarStore(s => s.isOpen || s.searchInputFocusedId !== null)

  const { name, minimize, children } = category

  if (!children?.length) {
    return null
  }

  const orderedChildren = children.sort((a, b) => a.position - b.position)

  return (
    <>
      <Typography
        variant="sectionTitle"
        className={cn(
          'text-hit-gray pt-4 pb-1 pl-4 text-sm font-normal text-nowrap transition-all duration-150',
          !isSidebarOpen && 'pl-[11px]',
        )}
      >
        {isSidebarOpen ? name : minimize}
      </Typography>
      <div>
        {orderedChildren.map(product => (
          <SidebarProductsProduct key={product.id} product={product} />
        ))}
      </div>
    </>
  )
}

export default SidebarProductsCategory
